module.exports = __webpack_public_path__ + "static/images/copy2.d41126f3c33504c491a4af10fdd2be09.svg";